import { ShoppingCart } from '@mui/icons-material';
import { CustomCheckoutManager } from '../modules/custom-checkout/CustomCheckoutManager';
import { RouteType } from './types';
import { routePaths } from './routePaths';

const CustomCheckout: RouteType = {
  exact: true,
  path: routePaths.customCheckout,
  title: 'Custom Checkout',
  icon: ShoppingCart,
  component: () => <CustomCheckoutManager />,
  permission: 'canCreateCustomCheckout',
};

export default CustomCheckout;
